

import { IState } from '../../../core/IState';
import { RequestsController } from './requestsController'; 
import '../requestList/directives/requestListDirective';
import '../requestList/services/requestListService';
import '../requestList/services/transportModeService';
import '../../navigation/navigationController';
import '../../navigation/navigationService';

import '../requestDetailEdit/controllers/requestDetailEditController';
import '../requestDetailEdit/states/requestDetailEditState';

import '../requestDetail/controllers/requestDetailController';
import '../requestDetail/states/requestDetailState';

export const requestsState : IState = {
    name: 'requests',
    url: '/requests',
    parent: 'root',
    template: require('./requests.html'),
    controller: RequestsController,
    controllerAs: 'requestsVM',
    data: {
        title: 'Requests',
        requiredFeature: 'Requests'
    }
}

angular.module('deliveryCreate.app').config([
    '$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
        $stateProvider.state(requestsState);
    }
]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requests/requestsState.ts
 **/